import useSWR from 'swr'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { AxiosError, AxiosResponse } from 'axios'
import { useState, useEffect } from 'react'

export interface FinancialItensOriginalProps {
  chave?: string
  descricao?: string
  descricaoEdicao?: string
  detalhamento?: string
  origem?: string
  omie?: string
  total_calculo?: number
  deletar?: number
  idItem?: string
  externoId?: string
  dados?: string
  description?: string
  formatedValue?: string
}

export interface DebitsObjectProps {
  data: FinancialItensOriginalProps[]
  totalRaw: number
  totalFormated: string
}
export interface FinancialItensResponseDataProps {
  otherDebitsObjet: {
    data: FinancialItensOriginalProps[]
  }
  servicesObject: {
    data: FinancialItensOriginalProps[]
  }

  totalDebitsRaw: number
  totalDebitsFormated: string
}

export interface FinancialItensResponseParams {
  success: boolean
  data: FinancialItensResponseDataProps
}
export interface useFinancialCloseDebits {
  financialDebits: AxiosResponse<FinancialItensResponseParams> | undefined
  isLoadingDebits: boolean
  isErrorDebits: AxiosError
}

const useSWRRequest = (eventId: number): useFinancialCloseDebits => {
  const url: string = `producer/analytics/finacialCloseDebits?eventId=${eventId}`

  const fetchData = async (): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().get(url)
  }

  const { data, error, isLoading } = useSWR(url, fetchData, {
    refreshInterval: 600000,
  })

  return {
    financialDebits: data,
    isLoadingDebits: isLoading,
    isErrorDebits: error,
  }
}

export interface DebitsProps {
  otherDebitsData: FinancialItensOriginalProps[]
  servicesData: FinancialItensOriginalProps[]
  debitsFormatedTotal: string
  debitsRawTotal: number
  isLoading: boolean
  isErrorDebits: undefined | AxiosError
}

export const useFinancialClosingDebits = (eventId: number): any => {
  const [debits, setDebits] = useState<DebitsProps>({
    otherDebitsData: [],
    servicesData: [],
    debitsFormatedTotal: '',
    debitsRawTotal: 0,
    isLoading: true,
    isErrorDebits: undefined,
  })

  const { financialDebits, isLoadingDebits, isErrorDebits } =
    useSWRRequest(eventId)

  useEffect(() => {
    if (financialDebits !== undefined) {
      const debitsRaw = financialDebits.data.data
      setDebits({
        otherDebitsData: debitsRaw.otherDebitsObjet.data,
        servicesData: debitsRaw.servicesObject.data,
        debitsFormatedTotal: debitsRaw.totalDebitsFormated,
        debitsRawTotal: debitsRaw.totalDebitsRaw,
        isLoading: isLoadingDebits,
        isErrorDebits: isErrorDebits,
      })
    }
  }, [financialDebits, isLoadingDebits, isErrorDebits])

  return { debits }
}
